'use strict';
require('whatwg-fetch');
var progress = require('./progress'),
    util = require('./util');

var currentRequests = [];

/**
 * @function
 * @description Ajax request to get json response
 * @param {Boolean} async  Asynchronous or not
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 */
var getJson = function (options) {
    options.url = util.toAbsoluteUrl(options.url);
    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    currentRequests[options.url] = true;

    // make the server call
    $.ajax({
        dataType: 'json',
        url: options.url,
        method: !options.method ? 'get' : options.method,
        async: (typeof options.async === 'undefined' || options.async === null) ? true : options.async,
        data: options.data || {}
    })
    // success
    .done(function (response) {
        if (options.callback) {
            options.callback(response);
        }
    })
    // failed
    .fail(function (xhr, textStatus) {
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        if (options.callback) {
            options.callback(null);
        }
    })
    // executed on success or fail
    .always(function () {
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};

/**
 * 
 * @param {Object} options 
 * @property {String} options.url request URL
 * @property {Object} options.data Name/Value pair data request
 * @property {Function} options.callback callback function after response
 * @property {String} options.target Selector or element that will receive content
 * @property {String} options.method http method
 * @property {String} options.credentials whether the user agent should send cookies from the other domain in the case of cross-origin requests. 
 * @property {String} options.cache cache setting
 */
var fetchData = function (options) {
    let {url, data, callback, target, method, credentials, cache} = options;
    /**
     * @example 
     * const init = {
     * credentials: 'include',
     * method: 'get',
     * cache: 'default'
     * }
     */
    let init = {};
    url = util.toAbsoluteUrl(url);
    // return if no url exists or url matches a current request
    if (!url || currentRequests[url]) {
        return;
    }
    currentRequests[options.url] = true;
    // setup the init setting
    method = method || 'get';
    credentials = credentials || 'include';
    cache = cache || 'default';
    init = {method, credentials, cache};
    if (data !== undefined) {
        if (method.toLowerCase() === 'get') {
            url = `${url}&${data}`
        } else {
            init =  {...init, body: data};
        }
        
    }

    //make the ajax call
    fetch(url, init)
    .then(response => {
        if(!response.ok) {
            throw new Error("HTTP error, status = " + response.status);
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            return response.clone().json();
        } else {
            return response.clone().text();
        }
       
    })
    .then(response => {
        if (target) {
            $(target).empty().html(response);
        }
        if (callback) {
            callback(response);
        }
    })
    .catch((error) => {
        console.error('fetch error:' + error );
        if (error === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        if (callback) {
            callback(null, error);
        }
    })
    .then(()=> {
        progress.hide();
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    })
    
} 
/**
 * @function
 * @description ajax request to load html response in a given container
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 * @param {Object} target Selector or element that will receive content
 */
var load = function (options) {
    options.url = util.toAbsoluteUrl(options.url);
    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    currentRequests[options.url] = true;

    // make the server call
    $.ajax({
        dataType: 'html',
        url: util.appendParamToURL(options.url, 'format', 'ajax'),
        method: !options.method ? 'get' : options.method,
        data: options.data,
        xhrFields: {
            withCredentials: true
        }
    })
    .done(function (response) {
        // success
        if (options.target) {
            $(options.target).empty().html(response);
        }
        if (options.callback) {
            options.callback(response);
        }
    })
    .fail(function (xhr, textStatus) {
        // failed
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        if (options.callback) {
            options.callback(null, textStatus);
        }
    })
    .always(function () {
        progress.hide();
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};

exports.getJson = getJson;
exports.load = load;
exports.fetchData = fetchData;